var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-tabs",
    {
      ref: "tabs",
      staticClass: "tabs",
      attrs: { "md-active-tab": _vm.activeTab, "md-dynamic-height": "" },
      on: { "md-changed": _vm.changed }
    },
    [
      _c(
        "md-tab",
        {
          attrs: {
            id: "Overview",
            name: "Overview",
            "md-label":
              _vm.activeTab === "Overview" ? _vm.i18n.sale_tab_overview() : "",
            "md-icon":
              _vm.activeTab === "Overview" ? "" : "format_list_bulleted"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "container container_30 text_small tabs__tab-inner"
            },
            [
              _c("description-tab", { attrs: { description: _vm.description } })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-tab",
        {
          attrs: {
            id: "Details",
            name: "Details",
            "md-label":
              _vm.activeTab === "Details" ? _vm.i18n.sale_tab_details() : "",
            "md-icon": _vm.activeTab === "Details" ? "" : "info_outline"
          }
        },
        [
          _c(
            "div",
            { staticClass: "container container_30 tabs__tab-inner" },
            [_c("sale-tab", { attrs: { sale: _vm.sale } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-tab",
        {
          attrs: {
            id: "Token",
            name: "Token",
            "md-label":
              _vm.activeTab === "Token" ? _vm.i18n.sale_tab_token() : "",
            "md-icon": _vm.activeTab === "Token" ? "" : "toll"
          }
        },
        [
          _c(
            "div",
            { staticClass: "container container_30 tabs__tab-inner" },
            [_c("token-tab", { attrs: { token: _vm.token, sale: _vm.sale } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-tab",
        {
          ref: "video_tab",
          attrs: {
            id: "Banner",
            name: "Banner",
            "md-label":
              _vm.activeTab === "Banner" ? _vm.i18n.sale_tab_video() : "",
            "md-icon": _vm.activeTab === "Banner" ? "" : "videocam"
          }
        },
        [
          _c(
            "div",
            { staticClass: "container container_30 tabs__tab-inner" },
            [_c("sale-banner", { attrs: { sale: _vm.sale } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-tab",
        {
          ref: "update_tab",
          attrs: {
            id: "Updates",
            name: "Updates",
            "md-label":
              _vm.activeTab === "Updates" ? _vm.i18n.sale_tab_updates() : "",
            "md-icon": _vm.activeTab === "Updates" ? "" : "autorenew"
          }
        },
        [
          _c(
            "div",
            { staticClass: "container container_30 tabs__tab-inner" },
            [_c("updates-tab", { attrs: { sale: _vm.sale } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-tab",
        {
          ref: "doc_tab",
          attrs: {
            id: "Documents",
            name: "Documents",
            "md-label":
              _vm.activeTab === "Documents"
                ? _vm.i18n.sale_tab_documents()
                : "",
            "md-icon": _vm.activeTab === "Documents" ? "" : "folder"
          }
        },
        [
          _c(
            "div",
            { staticClass: "container container_30 tabs__tab-inner" },
            [
              _c("documents-tab", {
                attrs: { sale: _vm.sale },
                on: {
                  "is-fund-documents": function($event) {
                    return _vm.isFundDocumentsUploaded($event)
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.sale.isClosed &&
      _vm.sale.details.internal_type.toLowerCase() !== "crowdfunding" &&
      _vm.isMy
        ? _c(
            "md-tab",
            {
              attrs: {
                id: "Dividends",
                name: "Dividends",
                "md-label":
                  _vm.activeTab === "Dividends"
                    ? _vm.i18n.sale_tab_dividends()
                    : "",
                "md-icon": _vm.activeTab === "Dividends" ? "" : "percent"
              }
            },
            [
              _c(
                "div",
                { staticClass: "container container_30 tabs__tab-inner" },
                [
                  _c("dividends-tab", {
                    attrs: {
                      sale: _vm.sale,
                      isDocumentsUploaded: _vm.isDocumentsUploaded
                    },
                    on: {
                      "dividends-page-status": function($event) {
                        return _vm.setDividendsPage($event)
                      },
                      "show-doc-tab": function($event) {
                        return _vm.showDocTab()
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e682ddfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e682ddfc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/Sales.Tabs.vue
// module id = Up4k
// module chunks = 1